/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 *
 * API Title: claim
 * API Version: 4.24.0
 */
export var GenerativeAssessmentConclusion;
(function (GenerativeAssessmentConclusion) {
    GenerativeAssessmentConclusion["INVALID"] = "Invalid";
    GenerativeAssessmentConclusion["VALID"] = "Valid";
})(GenerativeAssessmentConclusion || (GenerativeAssessmentConclusion = {}));
export var GenerativeAssessmentState;
(function (GenerativeAssessmentState) {
    GenerativeAssessmentState["PENDING"] = "Pending";
    GenerativeAssessmentState["STORED"] = "Stored";
    GenerativeAssessmentState["REJECTED"] = "Rejected";
})(GenerativeAssessmentState || (GenerativeAssessmentState = {}));
export var GenerativeClaimModelDamagedItemType;
(function (GenerativeClaimModelDamagedItemType) {
    GenerativeClaimModelDamagedItemType["VEHICLE"] = "Vehicle";
    GenerativeClaimModelDamagedItemType["PERSON"] = "Person";
    GenerativeClaimModelDamagedItemType["OTHER"] = "Other";
})(GenerativeClaimModelDamagedItemType || (GenerativeClaimModelDamagedItemType = {}));
export var GenerativeClaimModelDamagedItemSubType;
(function (GenerativeClaimModelDamagedItemSubType) {
    GenerativeClaimModelDamagedItemSubType["UNFALL"] = "Unfall";
    GenerativeClaimModelDamagedItemSubType["PARKSCHADEN"] = "Parkschaden";
    GenerativeClaimModelDamagedItemSubType["WILD"] = "Wild";
    GenerativeClaimModelDamagedItemSubType["DIEBSTAHL"] = "Diebstahl";
    GenerativeClaimModelDamagedItemSubType["BEWEISSICHERUNG"] = "Beweissicherung";
    GenerativeClaimModelDamagedItemSubType["SONSTIGE"] = "Sonstige";
})(GenerativeClaimModelDamagedItemSubType || (GenerativeClaimModelDamagedItemSubType = {}));
export var GenerativeClaimModelDamagedItemDamageType;
(function (GenerativeClaimModelDamagedItemDamageType) {
    GenerativeClaimModelDamagedItemDamageType["UNVERMUTETES_NICHT_VERKEHRSBEDINGTES_ABBREMSEN"] = "UnvermutetesNichtVerkehrsbedingtesAbbremsen";
    GenerativeClaimModelDamagedItemDamageType["ABBIEGEN_NACH_LINKS"] = "AbbiegenNachLinks";
    GenerativeClaimModelDamagedItemDamageType["ABBIEGEN_NACH_RECHTS"] = "AbbiegenNachRechts";
    GenerativeClaimModelDamagedItemDamageType["AUFFAHREN"] = "Auffahren";
    GenerativeClaimModelDamagedItemDamageType["STREIFEN_ODER_ANFAHREN"] = "StreifenOderAnfahren";
    GenerativeClaimModelDamagedItemDamageType["VERLASSEN_DER_GEDACHTEN_SPUR__KURVEN_SCHNEIDEN_USW"] = "VerlassenDerGedachtenSpur_KurvenSchneiden_usw";
    GenerativeClaimModelDamagedItemDamageType["FALSCHES_EINORDNEN"] = "FalschesEinordnen";
    GenerativeClaimModelDamagedItemDamageType["EINFAHRT_ODER_AUSFAHRT__GRUNDSTUECK_USW"] = "EinfahrtOderAusfahrt_Grundstueck_usw";
    GenerativeClaimModelDamagedItemDamageType["NICHTBEACHTEN_VON_FUSSGAENGERN"] = "NichtbeachtenVonFussgaengern";
    GenerativeClaimModelDamagedItemDamageType["VERKEHRSBEHINDERNDES_HALTEN_ODER_PARKEN"] = "VerkehrsbehinderndesHaltenOderParken";
    GenerativeClaimModelDamagedItemDamageType["UEBERHOLEN_ODER_SPURWECHSEL"] = "UeberholenOderSpurwechsel";
    GenerativeClaimModelDamagedItemDamageType["NICHTBEACHTEN_DER_VORRANGBESTIMMUNGEN__AUCH_STOPTAFEL"] = "NichtbeachtenDerVorrangbestimmungen_AuchStoptafel";
    GenerativeClaimModelDamagedItemDamageType["RUECKWAERTSFAHREN_ODER_UMKEHREN"] = "RueckwaertsfahrenOderUmkehren";
    GenerativeClaimModelDamagedItemDamageType["VORWAERTS_ODER_RUECKWAERTS_FAHREN_BEIM_AUSPARKEN_ODER_EINPARKEN"] = "VorwaertsOderRueckwaertsFahrenBeimAusparkenOderEinparken";
    GenerativeClaimModelDamagedItemDamageType["SCHLEUDERN"] = "Schleudern";
    GenerativeClaimModelDamagedItemDamageType["UEBERMAESSIGE_GESCHWINDIGKEIT"] = "UebermaessigeGeschwindigkeit";
    GenerativeClaimModelDamagedItemDamageType["NICHTBEACHTEN_VON_KINDERN"] = "NichtbeachtenVonKindern";
    GenerativeClaimModelDamagedItemDamageType["NICHTABBLENDEN_ODER_FAHREN_OHNE_LICHT_ODER_UNBELEUCHTETES_FAHRZEUG"] = "NichtabblendenOderFahrenOhneLichtOderUnbeleuchtetesFahrzeug";
    GenerativeClaimModelDamagedItemDamageType["OEFFNEN_DER_WAGENTUERE_BESCHAEDIGT_EIN_ANDERES_OBJEKT"] = "OeffnenDerWagentuereBeschaedigtEinAnderesObjekt";
    GenerativeClaimModelDamagedItemDamageType["KOLLISION_MIT_RADFAHRER"] = "KollisionMitRadfahrer";
    GenerativeClaimModelDamagedItemDamageType["EINSTEIGEN_ODER_AUSSTEIGEN"] = "EinsteigenOderAussteigen";
    GenerativeClaimModelDamagedItemDamageType["STURM"] = "Sturm";
    GenerativeClaimModelDamagedItemDamageType["ERDBEBEN"] = "Erdbeben";
    GenerativeClaimModelDamagedItemDamageType["WILDSCHADEN"] = "Wildschaden";
    GenerativeClaimModelDamagedItemDamageType["BRANDSCHADEN"] = "Brandschaden";
    GenerativeClaimModelDamagedItemDamageType["TERROR"] = "Terror";
    GenerativeClaimModelDamagedItemDamageType["KRIEG"] = "Krieg";
    GenerativeClaimModelDamagedItemDamageType["HOCHGESCHLEUDERTES_GESTEIN"] = "HochgeschleudertesGestein";
    GenerativeClaimModelDamagedItemDamageType["SCHADEN_BEIM_NORMALEN_BETRIEB__BEDIENUNGSFEHLER_ODER_BRUCH_ODER_BREMS_ODER_ABNUTZUNGSSCHADEN__AM_EIGENEN_FAHRZEUG"] = "SchadenBeimNormalenBetrieb_BedienungsfehlerOderBruchOderBremsOderAbnutzungsschaden_AmEigenenFahrzeug";
    GenerativeClaimModelDamagedItemDamageType["BESCHAEDIGEN_EINES_ANDEREN_OBJEKTS_DURCH_BELADEN_ODER_ENTLADEN"] = "BeschaedigenEinesAnderenObjektsDurchBeladenOderEntladen";
    GenerativeClaimModelDamagedItemDamageType["UNGENUEGEND_GESICHERTE_LADUNG"] = "UngenuegendGesicherteLadung";
    GenerativeClaimModelDamagedItemDamageType["ANDERER_EINFLUSS_ODER_MANGEL_DER_LADUNG"] = "AndererEinflussOderMangelDerLadung";
    GenerativeClaimModelDamagedItemDamageType["TEILUNGSABKOMMEN_REGRESS"] = "TeilungsabkommenRegress";
    GenerativeClaimModelDamagedItemDamageType["KOLLISION_MIT_UNBEKANNTEM_FAHRZEUG_ODER_VANDALISMUS__GILT_NUR_BEI_KASKO"] = "KollisionMitUnbekanntemFahrzeugOderVandalismus__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["FAHRZEUG_GEPARKT__GILT_NUR_BEI_KASKO"] = "FahrzeugGeparkt__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["HAGEL__GILT_NUR_BEI_KASKO"] = "Hagel__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["SCHNEEDRUCK__GILT_NUR_BEI_KASKO"] = "Schneedruck__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["FELSSTURZ_ODER_STEINSCHLAG_ODER_ERDRUTSCH__GILT_NUR_BEI_KASKO"] = "FelssturzOderSteinschlagOderErdrutsch__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["HOCHWASSER__GILT_NUR_BEI_KASKO"] = "Hochwasser__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["SONSTIGE_NATURGEWALTEN__GILT_NUR_BEI_KASKO"] = "SonstigeNaturgewalten__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["DACHLAWINE__GILT_NUR_BEI_KASKO"] = "Dachlawine__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["GLASBRUCH_WINDSCHUTZSCHEIBE__GILT_NUR_BEI_KASKO"] = "GlasbruchWindschutzscheibe__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["GLASBRUCH_KLEINGLAS__GILT_NUR_BEI_KASKO"] = "GlasbruchKleinglas__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["GLASBRUCH_RUNDUMVERGLASUNG__GILT_NUR_BEI_KASKO"] = "GlasbruchRundumverglasung__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["TEIL_DIEBSTAHL__GILT_NUR_BEI_KASKO"] = "TeilDiebstahl__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["TOTAL_DIEBSTAHL__GILT_NUR_BEI_KASKO"] = "TotalDiebstahl__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["BLITZSCHLAG__GILT_NUR_BEI_KASKO"] = "Blitzschlag__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["CYBERSCHAEDEN_AN_ELEKTROFAHRZEUGEN__GILT_NUR_BEI_KASKO"] = "CyberschaedenAnElektrofahrzeugen__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["DIEBSTAHL_AUS_K_F_Z_BEI_ELEKTROFAHRZEUGEN__GILT_NUR_BEI_KASKO"] = "DiebstahlAusKFZBeiElektrofahrzeugen__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["LADESCHAEDEN_AN_ELEKTROFAHRZEUGEN__GILT_NUR_BEI_KASKO"] = "LadeschaedenAnElektrofahrzeugen__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["TIERBISS__GILT_NUR_BEI_KASKO"] = "Tierbiss__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["TIERBISS_FOLGESCHAEDEN_BEI_ELEKTRO_FAHRZEUGEN__GILT_NUR_BEI_KASKO"] = "TierbissFolgeschaedenBeiElektroFahrzeugen__giltNurBeiKasko";
    GenerativeClaimModelDamagedItemDamageType["UNBEKANNTER_HERGANG__WENN_SONST_NICHTS_ZUTREFFEND"] = "UnbekannterHergang__wennSonstNichtsZutreffend";
})(GenerativeClaimModelDamagedItemDamageType || (GenerativeClaimModelDamagedItemDamageType = {}));
export var GenerativeClaimModelDamagedItemDamageConsequence;
(function (GenerativeClaimModelDamagedItemDamageConsequence) {
    GenerativeClaimModelDamagedItemDamageConsequence["SACHSCHADEN"] = "Sachschaden";
    GenerativeClaimModelDamagedItemDamageConsequence["PERSONENSCHADEN"] = "Personenschaden";
})(GenerativeClaimModelDamagedItemDamageConsequence || (GenerativeClaimModelDamagedItemDamageConsequence = {}));
export var GenerativeClaimModelPersonContactDataRole;
(function (GenerativeClaimModelPersonContactDataRole) {
    GenerativeClaimModelPersonContactDataRole["EMAILSIGNATUR"] = "Emailsignatur";
    GenerativeClaimModelPersonContactDataRole["VERSICHERUNGSNEHMER"] = "Versicherungsnehmer";
    GenerativeClaimModelPersonContactDataRole["VERSICHERUNGSNEHMER_LENKER"] = "VersicherungsnehmerLenker";
    GenerativeClaimModelPersonContactDataRole["ANSPRUCHSTELLER"] = "Anspruchsteller";
    GenerativeClaimModelPersonContactDataRole["ANSPRUCHSTELLER_LENKER"] = "AnspruchstellerLenker";
    GenerativeClaimModelPersonContactDataRole["KFZ_BETEILIGTER"] = "KfzBeteiligter";
    GenerativeClaimModelPersonContactDataRole["KFZ_BETEILIGTER_LENKER"] = "KfzBeteiligterLenker";
    GenerativeClaimModelPersonContactDataRole["ZEUGE"] = "Zeuge";
    GenerativeClaimModelPersonContactDataRole["RECHTSANWALT"] = "Rechtsanwalt";
    GenerativeClaimModelPersonContactDataRole["SACHVERSTAENDIGER"] = "Sachverstaendiger";
    GenerativeClaimModelPersonContactDataRole["WERKSTAETTE"] = "Werkstaette";
    GenerativeClaimModelPersonContactDataRole["TOP_REPORT"] = "TopReport";
    GenerativeClaimModelPersonContactDataRole["VERSICHERUNGSGESELLSCHAFT"] = "Versicherungsgesellschaft";
    GenerativeClaimModelPersonContactDataRole["VERSICHERUNGSMAKLER"] = "Versicherungsmakler";
    GenerativeClaimModelPersonContactDataRole["VERSICHERUNGS_MITARBEITER_FACHKRAFT"] = "VersicherungsMitarbeiterFachkraft";
    GenerativeClaimModelPersonContactDataRole["UNKNOWN"] = "Unknown";
})(GenerativeClaimModelPersonContactDataRole || (GenerativeClaimModelPersonContactDataRole = {}));
export var GenerativeClaimModelPredictedClaimLineOfBusiness;
(function (GenerativeClaimModelPredictedClaimLineOfBusiness) {
    GenerativeClaimModelPredictedClaimLineOfBusiness["HAFTPFLICHT"] = "Haftpflicht";
    GenerativeClaimModelPredictedClaimLineOfBusiness["KASKO"] = "Kasko";
})(GenerativeClaimModelPredictedClaimLineOfBusiness || (GenerativeClaimModelPredictedClaimLineOfBusiness = {}));
export var GenerativeClaimModelBusinessCase;
(function (GenerativeClaimModelBusinessCase) {
    GenerativeClaimModelBusinessCase["SONSTIGES"] = "Sonstiges";
    GenerativeClaimModelBusinessCase["CLAIM_MOTOR_SCHADENMELDUNG_NEU"] = "ClaimMotorSchadenmeldungNeu";
    GenerativeClaimModelBusinessCase["CLAIM_MOTOR_SCHADENMELDUNG_URGENZ"] = "ClaimMotorSchadenmeldungUrgenz";
    GenerativeClaimModelBusinessCase["CLAIM_PROPERTY_SCHADENMELDUNG_NEU"] = "ClaimPropertySchadenmeldungNeu";
    GenerativeClaimModelBusinessCase["CLAIM_PROPERTY_SCHADENMELDUNG_URGENZ"] = "ClaimPropertySchadenmeldungUrgenz";
    GenerativeClaimModelBusinessCase["CLAIM_LEGAL_EXPENSES_SCHADENMELDUNG_NEU"] = "ClaimLegalExpensesSchadenmeldungNeu";
    GenerativeClaimModelBusinessCase["CLAIM_LEGAL_EXPENSES_SCHADENMELDUNG_URGENZ"] = "ClaimLegalExpensesSchadenmeldungUrgenz";
})(GenerativeClaimModelBusinessCase || (GenerativeClaimModelBusinessCase = {}));
export var GenerativeContextTopic;
(function (GenerativeContextTopic) {
    GenerativeContextTopic["CLAIM_MOTOR"] = "ClaimMotor";
    GenerativeContextTopic["CLAIM_PROPERTY"] = "ClaimProperty";
    GenerativeContextTopic["CLAIM_LEGAL_EXPENSES"] = "ClaimLegalExpenses";
})(GenerativeContextTopic || (GenerativeContextTopic = {}));
export var DamagedObjectType;
(function (DamagedObjectType) {
    DamagedObjectType["_1001"] = "1001";
    DamagedObjectType["_2000"] = "2000";
    DamagedObjectType["_2001"] = "2001";
    DamagedObjectType["_2014"] = "2014";
    DamagedObjectType["_2141"] = "2141";
    DamagedObjectType["_2902"] = "2902";
    DamagedObjectType["_2903"] = "2903";
})(DamagedObjectType || (DamagedObjectType = {}));
export var InspectionType;
(function (InspectionType) {
    InspectionType["EXPERT"] = "EXPERT";
    InspectionType["MANUAL"] = "MANUAL";
    InspectionType["ANNUITY"] = "ANNUITY";
    InspectionType["PROVIDER"] = "PROVIDER";
})(InspectionType || (InspectionType = {}));
export var InspectionState;
(function (InspectionState) {
    InspectionState["INCOMPLETE"] = "incomplete";
    InspectionState["CONFIRMED"] = "confirmed";
    InspectionState["REJECTED"] = "rejected";
})(InspectionState || (InspectionState = {}));
export var InspectionMeasure;
(function (InspectionMeasure) {
    InspectionMeasure["VALUE"] = "Value";
    InspectionMeasure["PRECENT"] = "Precent";
    InspectionMeasure["DAYS"] = "Days";
})(InspectionMeasure || (InspectionMeasure = {}));
export var ReasonType;
(function (ReasonType) {
    ReasonType["WARNING"] = "warning";
    ReasonType["ERROR"] = "error";
})(ReasonType || (ReasonType = {}));
export var SegmentKey;
(function (SegmentKey) {
    SegmentKey["_01_0_AH"] = "01.0_AH";
    SegmentKey["_02_0_AK"] = "02.0_AK";
    SegmentKey["_02_1_VK"] = "02.1_VK";
    SegmentKey["_02_2_TK"] = "02.2_TK";
    SegmentKey["_04_0_AS"] = "04.0_AS";
    SegmentKey["_03_0_IU"] = "03.0_IU";
    SegmentKey["_05_0_U"] = "05.0_U";
    SegmentKey["_06_0_VU"] = "06.0_VU";
    SegmentKey["_07_0_PH"] = "07.0_PH";
    SegmentKey["_08_0_RS"] = "08.0_RS";
    SegmentKey["_09_0_LK"] = "09.0_LK";
    SegmentKey["_10_0_ED"] = "10.0_ED";
    SegmentKey["_12_0_HH"] = "12.0_HH";
    SegmentKey["_13_0_EB"] = "13.0_EB";
    SegmentKey["_14_0_EF"] = "14.0_EF";
    SegmentKey["_15_0_LW"] = "15.0_LW";
    SegmentKey["_16_0_GL"] = "16.0_GL";
    SegmentKey["_17_0_V"] = "17.0_V";
    SegmentKey["_18_0_ST"] = "18.0_ST";
    SegmentKey["_19_0_BW"] = "19.0_BW";
    SegmentKey["_20_0_FE"] = "20.0_FE";
    SegmentKey["_21_0_TB"] = "21.0_TB";
    SegmentKey["_22_0_BU"] = "22.0_BU";
    SegmentKey["_23_0_MB"] = "23.0_MB";
    SegmentKey["_24_0_KG"] = "24.0_KG";
    SegmentKey["_26_0_EG"] = "26.0_EG";
    SegmentKey["_27_0_TR"] = "27.0_TR";
    SegmentKey["_28_0_FB"] = "28.0_FB";
    SegmentKey["_29_0_FF"] = "29.0_FF";
    SegmentKey["_37_0_FL"] = "37.0_FL";
    SegmentKey["_40_0_MR"] = "40.0_MR";
    SegmentKey["_41_0_BM"] = "41.0_BM";
    SegmentKey["_42_0_MU"] = "42.0_MU";
    SegmentKey["_43_0_MM"] = "43.0_MM";
    SegmentKey["_44_0_MG"] = "44.0_MG";
    SegmentKey["_46_0_PC"] = "46.0_PC";
    SegmentKey["_96_0_LI"] = "96.0_LI";
    SegmentKey["_97_0_LH"] = "97.0_LH";
    SegmentKey["_98_0_LF"] = "98.0_LF";
    SegmentKey["_99_0_LC"] = "99.0_LC";
    SegmentKey["_00_0_XX"] = "00.0_XX";
})(SegmentKey || (SegmentKey = {}));
export var Source;
(function (Source) {
    Source["HOST"] = "HOST";
    Source["INSIS"] = "INSIS";
    Source["LEGACY"] = "LEGACY";
})(Source || (Source = {}));
export var ProductCategory;
(function (ProductCategory) {
    ProductCategory["MOTOR"] = "Motor";
    ProductCategory["NON_MOTOR"] = "NonMotor";
    ProductCategory["LIFE"] = "Life";
})(ProductCategory || (ProductCategory = {}));
export var ClaimNotificationSource;
(function (ClaimNotificationSource) {
    ClaimNotificationSource["TELEFON"] = "telefon";
    ClaimNotificationSource["EMAIL"] = "email";
    ClaimNotificationSource["MAKLERNETZ"] = "maklernetz";
    ClaimNotificationSource["KSS"] = "kss";
    ClaimNotificationSource["PORTAL"] = "portal";
    ClaimNotificationSource["POST"] = "post";
    ClaimNotificationSource["FAX"] = "fax";
    ClaimNotificationSource["ZAPP"] = "zapp";
    ClaimNotificationSource["PERSOENLICH"] = "persoenlich";
    ClaimNotificationSource["SONSTIGES"] = "sonstiges";
})(ClaimNotificationSource || (ClaimNotificationSource = {}));
export var ClaimClassification;
(function (ClaimClassification) {
    ClaimClassification["VOLLAUTOMATISIERTER_SCHADEN"] = "vollautomatisierterSchaden";
    ClaimClassification["KURZSCHADEN"] = "kurzschaden";
    ClaimClassification["EXPRESSSCHADEN"] = "expressschaden";
    ClaimClassification["SPEZIALSCHADEN"] = "spezialschaden";
    ClaimClassification["KOERPERSCHADEN"] = "koerperschaden";
    ClaimClassification["GLOBAL_CORPORATE_SCHADEN"] = "globalCorporateSchaden";
    ClaimClassification["MITVERSICHERTER_SCHADEN"] = "mitversicherterSchaden";
})(ClaimClassification || (ClaimClassification = {}));
export var PremiumCodeList;
(function (PremiumCodeList) {
    PremiumCodeList["G_"] = "G/";
    PremiumCodeList["P_N"] = "P/N";
    PremiumCodeList["P_G"] = "P/G";
    PremiumCodeList["G_G"] = "G/G";
    PremiumCodeList["N_G"] = "N/G";
    PremiumCodeList["N_N"] = "N/N";
    PremiumCodeList["G_N"] = "G/N";
    PremiumCodeList["N"] = "N";
    PremiumCodeList["G"] = "G";
    PremiumCodeList["_G"] = "/G";
    PremiumCodeList["P_O"] = "P/O";
    PremiumCodeList["N_O"] = "N/O";
    PremiumCodeList["_"] = "/";
    PremiumCodeList["N_"] = "N/";
    PremiumCodeList["_0"] = "/0";
    PremiumCodeList["_O"] = "/O";
    PremiumCodeList["_N"] = "/N";
    PremiumCodeList["O"] = "O";
    PremiumCodeList["G_O"] = "G/O";
})(PremiumCodeList || (PremiumCodeList = {}));
export var Status;
(function (Status) {
    Status["W"] = "W";
    Status["O"] = "O";
    Status["A"] = "A";
    Status["U"] = "U";
    Status["R"] = "R";
    Status["E"] = "E";
    Status["G"] = "G";
    Status["S"] = "S";
})(Status || (Status = {}));
export var ClaimDataType;
(function (ClaimDataType) {
    ClaimDataType["CLAIM"] = "Claim";
    ClaimDataType["ZDB_CLAIM"] = "ZdbClaim";
    ClaimDataType["INSIS_CLAIM"] = "InsisClaim";
})(ClaimDataType || (ClaimDataType = {}));
export var LiabilityCodeList;
(function (LiabilityCodeList) {
    LiabilityCodeList["W"] = "W";
    LiabilityCodeList["N"] = "N";
    LiabilityCodeList["J"] = "J";
    LiabilityCodeList["JV"] = "JV";
    LiabilityCodeList["H_"] = "H?";
    LiabilityCodeList["O"] = "O";
    LiabilityCodeList["MV"] = "MV";
    LiabilityCodeList["MH"] = "MH";
    LiabilityCodeList["P"] = "P";
    LiabilityCodeList["NW"] = "NW";
    LiabilityCodeList["VO"] = "VO";
    LiabilityCodeList["G_"] = "G/";
    LiabilityCodeList["_0"] = "0";
})(LiabilityCodeList || (LiabilityCodeList = {}));
export var ObjectStateAuxilary;
(function (ObjectStateAuxilary) {
    ObjectStateAuxilary[ObjectStateAuxilary["_0"] = 0] = "_0";
    ObjectStateAuxilary[ObjectStateAuxilary["_11"] = 11] = "_11";
    ObjectStateAuxilary[ObjectStateAuxilary["_12"] = 12] = "_12";
    ObjectStateAuxilary[ObjectStateAuxilary["_13"] = 13] = "_13";
    ObjectStateAuxilary[ObjectStateAuxilary["_14"] = 14] = "_14";
    ObjectStateAuxilary[ObjectStateAuxilary["_15"] = 15] = "_15";
    ObjectStateAuxilary[ObjectStateAuxilary["_16"] = 16] = "_16";
    ObjectStateAuxilary[ObjectStateAuxilary["_21"] = 21] = "_21";
    ObjectStateAuxilary[ObjectStateAuxilary["_22"] = 22] = "_22";
    ObjectStateAuxilary[ObjectStateAuxilary["_23"] = 23] = "_23";
    ObjectStateAuxilary[ObjectStateAuxilary["_27"] = 27] = "_27";
    ObjectStateAuxilary[ObjectStateAuxilary["_29"] = 29] = "_29";
    ObjectStateAuxilary[ObjectStateAuxilary["_28"] = 28] = "_28";
    ObjectStateAuxilary[ObjectStateAuxilary["_17"] = 17] = "_17";
})(ObjectStateAuxilary || (ObjectStateAuxilary = {}));
export var DamagedObjectRisk;
(function (DamagedObjectRisk) {
    DamagedObjectRisk["PERS"] = "PERS";
    DamagedObjectRisk["SACHS"] = "SACHS";
    DamagedObjectRisk["REIN"] = "REIN";
    DamagedObjectRisk["ABG_VERM"] = "ABG_VERM";
    DamagedObjectRisk["BRAND"] = "BRAND";
    DamagedObjectRisk["EXPL"] = "EXPL";
    DamagedObjectRisk["SCHMOR"] = "SCHMOR";
    DamagedObjectRisk["DIEBST"] = "DIEBST";
    DamagedObjectRisk["UNTER"] = "UNTER";
    DamagedObjectRisk["UNBEF"] = "UNBEF";
    DamagedObjectRisk["RAUB"] = "RAUB";
    DamagedObjectRisk["NATUR"] = "NATUR";
    DamagedObjectRisk["TIER_KOLL"] = "TIER_KOLL";
    DamagedObjectRisk["TIER"] = "TIER";
    DamagedObjectRisk["GLAS"] = "GLAS";
    DamagedObjectRisk["KLEIN_GLAS"] = "KLEIN_GLAS";
    DamagedObjectRisk["VERBR"] = "VERBR";
    DamagedObjectRisk["PARK"] = "PARK";
    DamagedObjectRisk["VANDAL"] = "VANDAL";
    DamagedObjectRisk["UNFALL"] = "UNFALL";
    DamagedObjectRisk["GEPLATZ"] = "GEPLATZ";
    DamagedObjectRisk["FAHR_KOLL"] = "FAHR_KOLL";
    DamagedObjectRisk["SCHLUSS"] = "SCHLUSS";
    DamagedObjectRisk["DOKUM"] = "DOKUM";
    DamagedObjectRisk["EINBRUCH"] = "EINBRUCH";
    DamagedObjectRisk["UNFALL_KOS"] = "UNFALL_KOS";
    DamagedObjectRisk["DAUER"] = "DAUER";
    DamagedObjectRisk["TODES"] = "TODES";
    DamagedObjectRisk["BEST"] = "BEST";
    DamagedObjectRisk["TAG"] = "TAG";
    DamagedObjectRisk["ABG_VERM_A"] = "ABG_VERM_A";
    DamagedObjectRisk["REIN_A"] = "REIN_A";
    DamagedObjectRisk["SACHS_A"] = "SACHS_A";
    DamagedObjectRisk["PERS_A"] = "PERS_A";
    DamagedObjectRisk["UNFALL_VK"] = "UNFALL_VK";
    DamagedObjectRisk["TOTALSH_VK"] = "TOTALSH_VK";
    DamagedObjectRisk["DIEBST_VK"] = "DIEBST_VK";
    DamagedObjectRisk["UNFALL_G"] = "UNFALL_G";
    DamagedObjectRisk["NATUR_I"] = "NATUR_I";
    DamagedObjectRisk["TOTALSH_TK"] = "TOTALSH_TK";
    DamagedObjectRisk["DIEBST_TK"] = "DIEBST_TK";
    DamagedObjectRisk["UNFALL_TK"] = "UNFALL_TK";
    DamagedObjectRisk["EINBRUCH_I"] = "EINBRUCH_I";
    DamagedObjectRisk["VERBR_TKMP"] = "VERBR_TKMP";
    DamagedObjectRisk["VERBR_TKOP"] = "VERBR_TKOP";
    DamagedObjectRisk["UNFALL_CB"] = "UNFALL_CB";
    DamagedObjectRisk["KOSTEN"] = "KOSTEN";
    DamagedObjectRisk["KRANKENHAU"] = "KRANKENHAU";
    DamagedObjectRisk["SOFORT"] = "SOFORT";
    DamagedObjectRisk["DOCAUSLAND"] = "DOCAUSLAND";
    DamagedObjectRisk["AUS_BERG"] = "AUS_BERG";
    DamagedObjectRisk["GARAGIERUN"] = "GARAGIERUN";
    DamagedObjectRisk["KOSTERSATZ"] = "KOSTERSATZ";
    DamagedObjectRisk["MEDHILFE"] = "MEDHILFE";
    DamagedObjectRisk["ABHOLUNGKI"] = "ABHOLUNGKI";
    DamagedObjectRisk["VERSCHROT"] = "VERSCHROT";
    DamagedObjectRisk["KOSTENVORS"] = "KOSTENVORS";
    DamagedObjectRisk["DOLMETSCHE"] = "DOLMETSCHE";
    DamagedObjectRisk["RETTUNGSAK"] = "RETTUNGSAK";
    DamagedObjectRisk["MEHRKOSTEN"] = "MEHRKOSTEN";
    DamagedObjectRisk["TAXIKOSTEN"] = "TAXIKOSTEN";
    DamagedObjectRisk["ZOLLGEBURH"] = "ZOLLGEBURH";
    DamagedObjectRisk["HEIMSCHAFF"] = "HEIMSCHAFF";
})(DamagedObjectRisk || (DamagedObjectRisk = {}));
export var EngineType;
(function (EngineType) {
    EngineType["ELECTRO"] = "electro";
    EngineType["FUEL_CELL"] = "fuelCell";
    EngineType["GAS"] = "gas";
    EngineType["HYBRID"] = "hybrid";
    EngineType["ICE"] = "ice";
    EngineType["OTHER_ENGINE"] = "otherEngine";
    EngineType["NO_ENGINE"] = "noEngine";
    EngineType["DIESEL"] = "diesel";
    EngineType["PETROL"] = "petrol";
})(EngineType || (EngineType = {}));
export var FuelType;
(function (FuelType) {
    FuelType["NO_DRIVE"] = "noDrive";
    FuelType["OTHER"] = "other";
    FuelType["UNKNOWN"] = "unknown";
    FuelType["PETROL"] = "petrol";
    FuelType["GAS"] = "gas";
    FuelType["ELECTRIC"] = "electric";
    FuelType["DIESEL"] = "diesel";
    FuelType["ETHANOL"] = "ethanol";
    FuelType["METHANE"] = "methane";
    FuelType["HYDROGEN"] = "hydrogen";
    FuelType["NATURAL_GAS"] = "naturalGas";
    FuelType["LIQUEFIED_GAS"] = "liquefiedGas";
    FuelType["MULTI_FUEL"] = "multiFuel";
    FuelType["PETROL_WITH_CATA"] = "petrolWithCata";
})(FuelType || (FuelType = {}));
export var VehicleType;
(function (VehicleType) {
    VehicleType["MOTORBIKE"] = "Motorbike";
    VehicleType["MOTORCYCLE"] = "Motorcycle";
    VehicleType["SEDAN"] = "Sedan";
    VehicleType["STATION_WAGON"] = "StationWagon";
    VehicleType["AKR"] = "AKR";
    VehicleType["AOM"] = "AOM";
    VehicleType["APK"] = "APK";
    VehicleType["ARB"] = "ARB";
    VehicleType["ASO"] = "ASO";
    VehicleType["AWO"] = "AWO";
    VehicleType["BRD"] = "BRD";
    VehicleType["DIV"] = "DIV";
    VehicleType["DRM"] = "DRM";
    VehicleType["EPK"] = "EPK";
    VehicleType["FWA"] = "FWA";
    VehicleType["FWW"] = "FWW";
    VehicleType["KKR"] = "KKR";
    VehicleType["KOM"] = "KOM";
    VehicleType["KRA"] = "KRA";
    VehicleType["KRF"] = "KRF";
    VehicleType["L6"] = "L6";
    VehicleType["L7"] = "L7";
    VehicleType["LKF"] = "LKF";
    VehicleType["LKW"] = "LKW";
    VehicleType["MAE"] = "MAE";
    VehicleType["MDR"] = "MDR";
    VehicleType["MOF"] = "MOF";
    VehicleType["MOT"] = "MOT";
    VehicleType["MP1"] = "MP1";
    VehicleType["MP2"] = "MP2";
    VehicleType["MUF"] = "MUF";
    VehicleType["OMN"] = "OMN";
    VehicleType["PKW"] = "PKW";
    VehicleType["RET"] = "RET";
    VehicleType["ROL"] = "ROL";
    VehicleType["SAT"] = "SAT";
    VehicleType["SON"] = "SON";
    VehicleType["STR"] = "STR";
    VehicleType["TRA"] = "TRA";
    VehicleType["VKF"] = "VKF";
    VehicleType["WML"] = "WML";
    VehicleType["WMP"] = "WMP";
    VehicleType["ZM1"] = "ZM1";
    VehicleType["ZM2"] = "ZM2";
    VehicleType["ZMM"] = "ZMM";
    VehicleType["ZMP"] = "ZMP";
    VehicleType["UNB"] = "UNB";
})(VehicleType || (VehicleType = {}));
export var LicensePlateType;
(function (LicensePlateType) {
    LicensePlateType["NORMAL"] = "normal";
    LicensePlateType["INTERCHANGEABLE"] = "interchangeable";
    LicensePlateType["TRIAL"] = "trial";
})(LicensePlateType || (LicensePlateType = {}));
export var UsageType;
(function (UsageType) {
    UsageType["OWN_USE"] = "ownUse";
    UsageType["FARM_USE"] = "farmUse";
    UsageType["SPED_USE"] = "spedUse";
    UsageType["FACTORY_TRAFFIC_USE"] = "factoryTrafficUse";
    UsageType["COMMERCIAL_TRANSPORT_USE"] = "commercialTransportUse";
    UsageType["PASSENGER_TRANSPORT_USE"] = "passengerTransportUse";
    UsageType["COMMERCIAL_RENTAL_WITHOUT_DRIVER_USE"] = "commercialRentalWithoutDriverUse";
    UsageType["DANGEROUS_GOODS_TRANSPORT_USE"] = "dangerousGoodsTransportUse";
    UsageType["TAXI_USE"] = "taxiUse";
    UsageType["FURNITURE_TRANSPORT_USE"] = "furnitureTransportUse";
    UsageType["SCHOOL_VEHICLE_USE"] = "schoolVehicleUse";
    UsageType["CIRCUS_EQUIP_TRANSPORT_USE"] = "circusEquipTransportUse";
    UsageType["PAID_PASSENGER_TRANSPORT_USE"] = "paidPassengerTransportUse";
    UsageType["ROAD_MAINTENANCE_USE"] = "roadMaintenanceUse";
    UsageType["ILLUMINATED_ROADS_USE"] = "illuminatedRoadsUse";
    UsageType["SEWER_MAINTENANCE_USE"] = "sewerMaintenanceUse";
    UsageType["MUNICIPAL_USE"] = "municipalUse";
    UsageType["BREAKDOWN_SERVICE_USE"] = "breakdownServiceUse";
    UsageType["SPECIAL_TRANSPORT_USE"] = "specialTransportUse";
    UsageType["DIPLOMAT_USE"] = "diplomatUse";
    UsageType["CONSUL_USE"] = "consulUse";
    UsageType["PUBLIC_SERVICE_USE"] = "publicServiceUse";
    UsageType["POSTAL_ADMIN_USE"] = "postalAdminUse";
    UsageType["AMBULANCE_SERVICE_USE"] = "ambulanceServiceUse";
    UsageType["FIRE_BRIGADE_USE"] = "fireBrigadeUse";
    UsageType["PRIVATE_AMBULANCE_USE"] = "privateAmbulanceUse";
    UsageType["OEBB_USE"] = "oebbUse";
    UsageType["FINANCE_MANAGEMENT_USE"] = "financeManagementUse";
    UsageType["TAX_INVESTIGATIONS_USE"] = "taxInvestigationsUse";
    UsageType["POLICE_USE"] = "policeUse";
    UsageType["MOUNTAIN_RESCUE_USE"] = "mountainRescueUse";
    UsageType["ARMY_USE"] = "armyUse";
    UsageType["PRESIDENT_TRANSPORT_USE"] = "presidentTransportUse";
    UsageType["STATE_FUNCTIONARIES_USE"] = "stateFunctionariesUse";
})(UsageType || (UsageType = {}));
export var ReserveState;
(function (ReserveState) {
    ReserveState["A"] = "a";
    ReserveState["NA"] = "na";
    ReserveState["R"] = "r";
})(ReserveState || (ReserveState = {}));
export var CoverCodeList;
(function (CoverCodeList) {
    CoverCodeList["J"] = "J";
    CoverCodeList["JV"] = "JV";
    CoverCodeList["O"] = "O";
    CoverCodeList["P"] = "P";
    CoverCodeList["W"] = "W";
    CoverCodeList["D0"] = "D0";
    CoverCodeList["DO"] = "DO";
    CoverCodeList["NV"] = "NV";
    CoverCodeList["D_"] = "D?";
    CoverCodeList["VO"] = "VO";
    CoverCodeList["V0"] = "V0";
    CoverCodeList["BK"] = "BK";
    CoverCodeList["VA"] = "VA";
    CoverCodeList["BT"] = "BT";
})(CoverCodeList || (CoverCodeList = {}));
export var DamagedObjectStatus;
(function (DamagedObjectStatus) {
    DamagedObjectStatus["UNVOLLSTAENDIG"] = "unvollstaendig";
    DamagedObjectStatus["OFFEN"] = "offen";
    DamagedObjectStatus["ABGESCHLOSSEN"] = "abgeschlossen";
    DamagedObjectStatus["WIEDEREROEFFNET"] = "wiedereroeffnet";
})(DamagedObjectStatus || (DamagedObjectStatus = {}));
// export enums as arrays so we can use them as options in ui
export const PremiumCodeListList = [
    'G/',
    'P/N',
    'P/G',
    'G/G',
    'N/G',
    'N/N',
    'G/N',
    'N',
    'G',
    '/G',
    'P/O',
    'N/O',
    '/',
    'N/',
    '/0',
    '/O',
    '/N',
    'O',
    'G/O',
];
export const StatusList = ['W', 'O', 'A', 'U', 'R', 'E', 'G', 'S'];
export const LiabilityCodeListList = [
    'W',
    'N',
    'J',
    'JV',
    'H?',
    'O',
    'MV',
    'MH',
    'P',
    'NW',
    'VO',
    'G/',
    '0',
];
export const CoverCodeListList = [
    'J',
    'JV',
    'O',
    'P',
    'W',
    'D0',
    'DO',
    'NV',
    'D?',
    'VO',
    'V0',
    'BK',
    'VA',
    'BT',
];
